import { Component } from '@angular/core';
import { PopoverController, NavController, Events } from 'ionic-angular';
import { EventCodes } from '../../core/codes';
import { FirebaseData } from '../../providers/firebase-data';
import { UserData } from '../../providers/user-data';
import { Utils } from '../../providers/utils';
import { NewsDetailsPage } from '../news/news-details';
import { PopoverCheckboxSelect } from '../../components/popover-checkbox-select';
import { AppSettings } from '../../config/app-settings';
import { PageBase } from '../../core/page-base';

import _ from 'lodash';


@Component({
  selector: 'page-news',
  templateUrl: 'news.html'
})
export class NewsPage extends PageBase {
	
  public newsItems: any;
  public newsCats: any;
  public selectedCats: any;
  public filteredItems: any;
  public isLoading: boolean = true;

  constructor(  	
    private popoverController: PopoverController,
    private firebaseData: FirebaseData,
    public events: Events,
    public nav: NavController,
    public userData: UserData,
    public settings: AppSettings) {
    super(settings, events, nav, userData);
  }

  ionViewDidEnter() {
    let self = this;
    self.loadPage();
  }

  private loadPage(){
    let self = this;
    this.loadCurrentUser().subscribe(()=>{
      console.log(self.currentUser);
    });    
    
    self.getNewsCats();
    self.events.subscribe(EventCodes.POPOVER_CHECKBOX_CHANGED, (item)=>{
       // Update checkboxList
      _.extend(_.find(self.newsCats, {key: item.key}), item);
     
      self.loadNewsFromSelectedCats();
    });

  }

  private getNewsCats(){
    var self = this;
    self.isLoading = true;
    self.firebaseData.get('news-category').subscribe(cat_data => {
      self.newsCats = Utils.toArray(cat_data);
      _.each(self.newsCats, function(cat){
        cat.checked = true;
      });

      // Get newsItems
      self.firebaseData.get('news').subscribe(news_data => {
        let _newsItems = Utils.toArray(news_data).reverse(); 
        self.newsItems = _newsItems;
        self.filteredItems = _newsItems;
        self.isLoading = false;
      });
    });
  }

  public getNewsCatById(id){
    let found:any = _.find(this.newsCats, function(cat:any){
      return cat.key == id;
    })

    if(found){
      return found.value;
    }else {
      return '';
    }
  }

  private loadNewsFromSelectedCats(){
    let self = this;   

    self.selectedCats = _.filter(self.newsCats, {checked: true});
    self.filteredItems = _.filter(self.newsItems, function(item: any){
      let foundCat = _.find(self.selectedCats, function(cat:any){
        return (_.indexOf(item.value.category, Number(cat.key)) > -1);
      });

      return (foundCat!=null);
    });
  }

  public viewByCategory(catId){
    _.each(this.newsCats, function(item){
      (item.checked = item.key == catId+'');
    });
    
    this.loadNewsFromSelectedCats();
  }

  public formatNum(num){
    if(!num){return "";}
    return Utils.formatNumberToString(num);
  }

  public getBrief(str){
    return str.replace(/<(?:.|\n)*?>/gm, '').substring(0, this.settings.briefMaxChar);
  }

  public loadNewsDetail(newsItem){
    this.nav.push(NewsDetailsPage, {item: newsItem});
  }

  public presentFilter(ev){
    let popover = this.popoverController.create(PopoverCheckboxSelect, {listName:'Category', items: this.newsCats});

    popover.present({ev: ev});
  }
}



// WEBPACK FOOTER //
// ./src/pages/news/news.ts